module.exports = __webpack_public_path__ + "processI.png";